import { TransactionDetailsTypeId } from '../../transaction-details.enums';
import { IpwSystemId, IpwSystemIdKey, ThirdPartySystemId } from '../../third-party-system.enums';

export const DealertrackIpwSystemId = IpwSystemId.DEALERTRACK;
export const DealertrackIpwSystemIdKey = IpwSystemIdKey.DEALERTRACK;
export const DealertrackThirdPartySystemId = ThirdPartySystemId.DEALERTRACK;

export const DealertrackPartsTransactionDetailsTypeId = TransactionDetailsTypeId.DEALERTRACK_PARTS;
export const DealertrackServiceTransactionDetailsTypeId =
    TransactionDetailsTypeId.DEALERTRACK_SERVICE;
export const DealertrackDealTransactionDetailsTypeId = TransactionDetailsTypeId.DEALERTRACK_DEAL;
export const DealertrackLeasingTransactionDetailsTypeId =
    TransactionDetailsTypeId.DEALERTRACK_LEASING;
export const DealertrackArStatementCustomersTransactionDetailsTypeId =
    TransactionDetailsTypeId.DEALERTRACK_AR_STATEMENT_CUSTOMERS;

export function isDealertrackIpwSystemId(
    systemId: IpwSystemId
): systemId is typeof DealertrackIpwSystemId {
    return systemId === DealertrackIpwSystemId;
}

export function isDealertrackThirdPartySystemId(
    systemId: ThirdPartySystemId
): systemId is typeof DealertrackThirdPartySystemId {
    return systemId === DealertrackThirdPartySystemId;
}
